import type {
  AdminAssignBody,
  AdminCardDto,
  AdminClientCardDto,
  AdminClientList,
  AdminClientPatch,
  AdminSummary,
  AdminWorkers,
} from '@getslot/api-client'
import { queryOptions } from '@tanstack/react-query'
import { api } from './session'

export const opsKeys = {
  summary: ['admin', 'summary'] as const,
  workers: ['admin', 'workers'] as const,
  clients: (q: string) => ['admin', 'clients', 'list', q] as const,
  client: (id: string) => ['admin', 'clients', 'card', id] as const,
}

/** Сводка и воркеры обновляются сами: пульс воркеров приходит раз в 10 секунд. */
export const summaryQuery = queryOptions({
  queryKey: opsKeys.summary,
  queryFn: ({ signal }) => api.get<AdminSummary>('/admin/summary', { signal }),
  refetchInterval: 15_000,
})

export const workersQuery = queryOptions({
  queryKey: opsKeys.workers,
  queryFn: ({ signal }) => api.get<AdminWorkers>('/admin/workers', { signal }),
  refetchInterval: 10_000,
})

export function clientsQuery(q: string) {
  const search = q === '' ? '' : `&q=${encodeURIComponent(q)}`
  return queryOptions({
    queryKey: opsKeys.clients(q),
    queryFn: ({ signal }) => api.get<AdminClientList>(`/admin/clients?limit=200${search}`, { signal }),
    refetchInterval: 30_000,
  })
}

export function clientQuery(id: string) {
  return queryOptions({
    queryKey: opsKeys.client(id),
    queryFn: ({ signal }) => api.get<AdminClientCardDto>(`/admin/clients/${encodeURIComponent(id)}`, { signal }),
    refetchInterval: 15_000,
  })
}

export function patchClient(id: string, body: AdminClientPatch): Promise<AdminClientCardDto> {
  return api.patch<AdminClientCardDto>(`/admin/clients/${encodeURIComponent(id)}`, body)
}

export function assign(id: string, body: AdminAssignBody): Promise<AdminCardDto> {
  return api.post<AdminCardDto>(`/admin/applications/${encodeURIComponent(id)}/assign`, body)
}
